import React from "react";
import image1 from '../../Images/grundsatz_prinzipien.webp';
import image2 from '../../Images/new3/Component 16.png';
import image3 from '../../Images/new3/Component 2.png';
import image4 from '../../Images/new3/Component 3.png';
import image5 from '../../Images/new3/Container.png';
import image6 from '../../Images/new3/Group1.png';
import image7 from '../../Images/img/Group 14.png';
import image8 from '../../Images/img/Group 25.png';
import useInViewOnce from "./useInViewOnce";
const Principle = () => {
  

    return (
        <div className="choose1 sp w-[90%] 2xl:w-[70%] mx-auto ">

            <h2 className="h2-mb h2-md h2-lg h2-2xl text-center mt-12 md:m-16">
                <span className="">Jetzt deine Homepage von Profis <br /> erstellen

                </span>
            </h2>
            <div className="max-w-[100%] mx-auto px-4">

                <div className="flex justify-center">
                    <div className="w-full ">
                        <div className="ops-card">
                            <div className="flex flex-col lg:flex-row items-center">

                                {/* LEFT IMAGE */}
                                <div className="w-full lg:w-1/2">
                                    <div className="ops-image-wrapper image-anime reveal overflow-visible">
                                        <img
                                            src={image1}
                                            alt=""
                                            className="w-full h-auto ops-main-image"
                                        />

                                        {/* Top Badge */}
                                        <div className={`ops-badge top-badge hidden md:block `}>
                                            <div className="flex items-center gap-2">
                                                <img src={image2} alt="" />
                                                <div className="grid">
                                                    <span className="text-muted font-bold text-sm">ABTEILUNG</span>
                                                    <strong>Webprojekte & Prozesse</strong>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Accuracy Badge */}
                                        <div className={`ops-badge accuracy-badge hidden md:block `}>
                                            <div className="flex items-center gap-2">
                                                <img src={image3} alt="" />
                                                <span>5 Jahre Erfahrung</span>
                                            </div>
                                        </div>

                                        {/* Bottom Stats Card */}
                                        <div className={`ops-stats-card hidden md:block  `}>
                                            <div className="flex items-center gap-2">
                                                <img src={image4} alt="" />
                                                <div className="flex items-center gap-2">
                                                    <span className="text-muted font-bold whitespace-nowrap">Realisierte Projekte</span>
                                                    <span className="bg-black text-white px-2 py-1 rounded-full">Erfolgreich</span>
                                                </div>
                                            </div>
                                            <h3 className="text-5xl font-bold">340+</h3>
                                            <div className="bars">
                                                <img src={image5} alt="" />
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                {/* RIGHT CONTENT */}
                                <div className="w-full lg:w-1/2">
                                    <div className="ops-content">
                                        {/* <h3 className="ops-title">
                                            Benutzerfreundliches <br /> Design
                                        </h3> */}
                                        <h3 className="h3-mb h3-md h3-lg h3-2xl mb-4">
                                            Warum individuelle Webseiten den Unterschied machen
                                        </h3>
                                        <p className="text-gray-600 mb-2">
                                            Template-Webseiten sehen oft gleich aus, sind langsam und schlecht optimiert.
                                        </p>
                                        <p className="text-bold mb-4">
                                            Unsere eigens entwickelten Webseiten sind:
                                        </p>

                                        <div className="ops-list">
                                            <div
                                                className={`ops-item `}
                                            >

                                                <div className="icon purple">
                                                    <img src={image6} alt="" />
                                                </div>
                                                <div>
                                                    <p className="font-bold">Einzigartig</p>
                                                    <p>Intuitive Bedienung und positive Nutzererfahrung stehen bei uns an erster Stelle.</p>


                                                </div>

                                            </div>

                                            <div
                                                className={`ops-item `}

                                            >
                                                <div className="icon red">
                                                    <img src={image7} alt="" />
                                                </div>
                                                <div>
                                                    <p className="font-bold">Schnell</p>
                                                    <p>Wir sorgen dafür, dass Kunden finden, was sie suchen – ohne Umwege.</p>


                                                </div>
                                            </div>

                                            <div
                                                className={`ops-item `}
                                            >

                                                <div className="icon green">
                                                    <img src={image8} alt="" />
                                                </div>
                                                <div>
                                                    <p className="font-bold">Suchmaschinenfreundlich</p>
                                                    <p>Design, das den Nutzer nicht überfordert, sondern leitet.</p>


                                                </div>
                                            </div>
                                            <div
                                                className={`ops-item `}
                                            >

                                                <div className="icon green">
                                                    <img src={image8} alt="" />
                                                </div>
                                                <div>
                                                    <p className="font-bold"> Auf Conversion ausgelegt</p>
                                                    <p>Design, das den Nutzer nicht überfordert, sondern leitet.</p>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Principle;
